const isProd = `${import.meta.env.VITE_APP_KEYCLOAK_URL}`.includes('qairn.fr');

const isDev = import.meta.env.DEV;

export { isProd, isDev };
